// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"Skeleton_skeleton__CjRFQ","lines":"Skeleton_lines__LNjHF","line":"Skeleton_line__ccbLI","load":"Skeleton_load___vdU_"};